export default function RestaurantNotFound() {
    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            padding: "20px",
            fontFamily: "sans-serif",
            backgroundColor: "#f5f5f5",
            textAlign: "center"
        }}>
            <h2 style={{
                fontSize: "clamp(24px, 5vw, 36px)",
                color: "#333",
                marginBottom: "16px",
                fontWeight: "600"
            }}>
                Restaurant not found
            </h2>
        </div>
    );
}
